import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';
import { DashboardComponent } from "./modules/admin/dashboard/dashboard.component";
import { AuthSignInComponent } from "./modules/auth/sign-in/sign-in.component";
import { checkLoginGuardGuard } from "./core/auth/guards/check-login-guard.guard";
import { adminAuthGuardGuard } from "./core/auth/guards/admin-auth-guard.guard";
import { AuthForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { AuthResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';
import { Error404Component } from './modules/admin/error/error-404/error-404.component';
import { ConfigurationComponent } from './modules/admin/configuration/configuration.component';
import { ShopifyConnectionComponent } from './modules/admin/shopify-connection/shopify-connection.component';
import { PartnerProfileComponent } from './modules/admin/partner-profile/partner-profile.component';
import { InventoryListComponent } from './modules/admin/inventory-management/inventory-list/inventory-list.component';
import { ShippingCostMatrixComponent } from "./modules/admin/shipping-cost-matrix/shipping-cost-matrix.component";
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: '' },

    // Auth routes for guests
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'shopify/callback', component: ShopifyConnectionComponent, title: 'Grimmor - Shopify' },
            { path: '', component: AuthSignInComponent, canActivate: [checkLoginGuardGuard] },
            { path: 'partner', component: AuthSignInComponent },
            { path: 'forgot-password', component: AuthForgotPasswordComponent, canActivate: [checkLoginGuardGuard], title: 'Grimmor - Admin Forgot Password' },
            { path: 'partner/forgot-password', component: AuthForgotPasswordComponent, title: 'Grimmor - Partner Forgot Password' },
            { path: 'reset-password', component: AuthResetPasswordComponent, canActivate: [checkLoginGuardGuard], title: 'Grimmor - Admin Reset Password' },
            { path: 'partner/reset-password', component: AuthResetPasswordComponent, title: 'Grimmor - Partner Set Password' },
            { path: 'partner/set-password', component: AuthResetPasswordComponent, title: 'Grimmor - Partner Set Password' },
            { path: 'set-password', component: AuthResetPasswordComponent, title: 'Grimmor - Partner Set Password' },
            // {path: 'admin/test', component: AuthConfirmationRequiredComponent , canActivate: [checkLoginGuardGuard]},
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'partner/sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
        ]
    },
    {
        path: '',
        canActivate: [adminAuthGuardGuard],
        canActivateChild: [adminAuthGuardGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'dashboard', component: DashboardComponent },
            { path: 'partner/dashboard', component: DashboardComponent },
            { path: 'user-management', loadChildren: () => import('app/modules/admin/user-management/user.routes') },
            { path: 'style-management', loadChildren: () => import('app/modules/admin/style-management/style.routes') },
            { path: 'master-brands', loadChildren: () => import('app/modules/admin/brand-management/brand.routes') },
            { path: 'content-management', loadChildren: () => import('app/modules/admin/cms/cms.routes') },
            { path: 'wardrobe-category-management', loadChildren: () => import('app/modules/admin/wardrobe-category-management/wardrobe-category.routes') },
            { path: 'season-management', loadChildren: () => import('app/modules/admin/season-management/season.routes') },
            { path: 'occasion-management', loadChildren: () => import('app/modules/admin/occasion-management/occasion.routes') },
            { path: 'advertise-management', loadChildren: () => import('app/modules/admin/advertise-management/advertise.routes') },
            { path: 'vintage-management', loadChildren: () => import('app/modules/admin/marketplace-management/marketplace.routes') },
            { path: 'partner-management', loadChildren: () => import('app/modules/admin/partner-management/partner.routes') },
            { path: 'product-management', loadChildren: () => import('app/modules/admin/product-management/product.routes') },
            { path: 'outfit-management', loadChildren: () => import('app/modules/admin/outfit-management/outfit.routes') },
            // {path: 'partner/product-management', loadChildren: () => import('app/modules/admin/product-management/product.routes')},
            { path: 'order-management', loadChildren: () => import('app/modules/admin/order-management/order.routes') },
            { path: 'report-management', loadChildren: () => import('app/modules/admin/report-management/report.routes') },
            { path: 'report-content-management', loadChildren: () => import('app/modules/admin/report-content-management/report-content.routes') },
            { path: 'ai-cost-management', loadChildren: () => import('app/modules/admin/ai-cost-management/ai-cost.routes') },
            { path: 'partner/order-management', loadChildren: () => import('app/modules/admin/order-management/order.routes') },
            { path: 'return-management', loadChildren: () => import('app/modules/admin/return-management/return.routes') },
            { path: 'partner/return-management', loadChildren: () => import('app/modules/admin/return-management/return.routes') },
            { path: 'configuration', component: ConfigurationComponent },
            { path: 'shipping-cost-matrix', component: ShippingCostMatrixComponent },
            { path: 'partner/shipping-cost-matrix', component: ShippingCostMatrixComponent },
            { path: 'my-profile', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'partner/my-profile', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'change-password', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'partner/change-password', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            // {path: '', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            { path: 'partner-profile', component: PartnerProfileComponent },
            { path: 'partner/inventory-management', component: InventoryListComponent },
            { path: 'inventory-management', component: InventoryListComponent },
            // {path: 'partner/:name/:brandId', loadChildren: () => import('app/modules/admin/partner-brands-management/partner-brand.routes')},
            { path: 'partner/product-management', loadChildren: () => import('app/modules/admin/partner-brands-management/partner-brand.routes') },

            { path: 'my-product-management', loadChildren: () => import('app/modules/admin/partner-brands-management/partner-brand.routes') },
            { path: 'partner/customer-management', loadChildren: () => import('app/modules/admin/customer-management/customer.routes') },
            { path: 'partner/collection-management', loadChildren: () => import('app/modules/admin/collection-management/collection.routes') },
            { path: 'collection-management', loadChildren: () => import('app/modules/admin/collection-management/collection.routes') },
            { path: 'brand-term-management', loadChildren: () => import('app/modules/admin/brand-terms/brand-terms.routes') },
            { path: 'prompt-management', loadChildren: () => import('app/modules/admin/prompt-management/prompt.routes') },
            { path: 'promo-code-management', loadChildren: () => import('app/modules/admin/promo-code-management/promo-code.routes') },
            { path: 'notification-management', loadChildren: () => import('app/modules/admin/notification-management/notification.routes') },

        ]
    },
    { path: '**', component: Error404Component },
];
